module.exports = __webpack_public_path__ + "img/w7.a9795ed9.svg";